export function formatStatus(value) {
  const map = new Map([
    [19, "Aguardando 1. Conexão"],
    [27, "Ativo"],
    [58, "Em aviso"],
    [43, "Bloqueado"],
    [26, "Não instalado"],
    [35, "Congelado"],
    [51, "Cancelado"],
    [52, "Cancelado inadimpl."],
    [96, "Isento"],
    [105, "Aguardando aceite"]
  ]);
  return map.get(value);
}

export function formatStatusBadgeColor(value) {
  const map = new Map([
    [19, "badge-green"],
    [27, "badge-green"],
    [58, "badge-yellow"],
    [43, "badge-red"],
    [26, "badge-yellow"],
    [35, "badge-red"],
    [51, "badge-red"],
    [52, "badge-red"],
    [96, "badge-green"],
    [105, "badge-green"]
  ]);
  return map.get(value);
}

export function formatTicketType(value) {
  const map = new Map([
    [10024, "Atendimento Web"],
    [10010, "Problemas Central Assinante"]
  ]);
  return map.get(value);
}

export function formatRelationship(value) {
  const map = new Map([
    [1, "Assinante"],
    [2, "Esposa(o)"],
    [3, "Filho(a)"],
    [4, "Pai/Mãe"],
    [5, "Outro Parente"],
    [6, "Funcionário"],
    [7, "Outros"],
    [8, "Colega de Trabalho"]
  ]);
  return map.get(value);
}
